module.exports = __webpack_public_path__ + "img/stock7.81f8d86e.png";